/**
 * Definition enum for address types within address records
 */
export var ADDRESS_TYPE;
(function (ADDRESS_TYPE) {
  ADDRESS_TYPE[ADDRESS_TYPE["MAILING"] = 0] = "MAILING";
  ADDRESS_TYPE[ADDRESS_TYPE["SERVICE"] = 1] = "SERVICE";
  ADDRESS_TYPE[ADDRESS_TYPE["PHYSICAL"] = 2] = "PHYSICAL";
  ADDRESS_TYPE[ADDRESS_TYPE["PRIMARY"] = 3] = "PRIMARY";
  ADDRESS_TYPE[ADDRESS_TYPE["SECONDARY"] = 4] = "SECONDARY";
})(ADDRESS_TYPE || (ADDRESS_TYPE = {}));